import React from 'react';

export const sizeData = [
  {
    id: 1,
    value: 'S'
  },
  {
    id: 2,
    value: 'M'
  },
  {
    id: 3,
    value: 'L'
  },
  {
    id: 4,
    value: 'XL'
  }
];

export const tshirtSizeData = [
  {
    id: 1,
    value: 'S'
  },
  {
    id: 2,
    value: 'M'
  },
  {
    id: 3,
    value: 'L'
  },
  {
    id: 4,
    value: 'XL'
  },
  {
    id: 5,
    value: '2XL'
  },
  {
    id: 6,
    value: '3XL'
  }
];

export const navItems = [
  {
    id: 1,
    label: 'riding jackets',
    value: 'jacket',
    icon:
      'https://reecommdev.blob.core.windows.net/re-assets/jacketAssets/icons/jacket.svg'
  },
  {
    id: 2,
    label: 'helmets',
    value: 'helmet',
    icon: 'https://reecommdev.blob.core.windows.net/re-assets/icons/helmet.svg'
  },
  {
    id: 3,
    label: 't-shirts',
    value: 'tshirt',
    icon: 'https://reecommdev.blob.core.windows.net/re-assets/icons/t-shirt.svg'
  }
];

export const helmetViewMaps = {
  front: {
    alpha: 1.57,
    beta: 1.57
  },
  default: {
    radius: 3
  },
  tshirtfront: {
    alpha: 1.57,
    beta: 1.57,
    radius: 2.3
  },
  tshirtback: {
    alpha: -1.57,
    beta: 1.57,
    radius: 2.3
  },
  back: {
    alpha: -1.57,
    beta: 1.57
  },
  left: {
    alpha: 3.14,
    beta: 1.57
  },
  right: {
    alpha: 0,
    beta: 1.57
  },
  top: {
    alpha: -4.84084521,
    beta: 0.009948377
  },
  jacketFront: {
    alpha: 7.8001767081469415,
    beta: 1.3175345369682965,
    radius: 5.312749986354204
  },
  jacketLeft: {
    alpha: 6.199970304233029,
    beta: 1.0792974579753676,
    radius: 5.312749986354204
  },
  jacketBack: {
    alpha: 4.543708958761183,
    beta: 1.5476015625000008,
    radius: 5.162155810506271
  }
};

export const tShirtBadgeMaps = {
  SL: {
    alpha: 3.2775538,
    beta: 1.4810864,
    radius: 2.3
  },
  SR: {
    alpha: 0.1,
    beta: 1.3346533,
    radius: 2.3
  },
  TL: {
    alpha: 2.40244572,
    beta: 0.86655597,
    radius: 2.3
  },
  TR: {
    alpha: 1,
    beta: 0.80005893,
    radius: 2.3
  },
  CT: {
    alpha: 1.5214035,
    beta: 0.80005893,
    radius: 2.3
  },
  BL: {
    alpha: 2.61153616,
    beta: 1.5683529,
    radius: 2.3
  },
  BR: {
    alpha: 1,
    beta: 1.5683529,
    radius: 2.3
  }
};

export const skuVariantMap = {
  HelmetOpenFace: {
    VSRT02: {
      S: 'RRGHECS00009',
      M: 'RRGHECS00010',
      L: 'RRGHECS00011',
      XL: 'RRGHECS00012'
    },
    VSRT01: {
      S: 'RRGHECS00013',
      M: 'RRGHECS00014',
      L: 'RRGHECS00015',
      XL: 'RRGHECS00016'
    },
    VSRT03: {
      // S: 'RRGHECS00017',
      M: 'RRGHECS00018',
      L: 'RRGHECS00019',
      // XL: 'RRGHECS00020'
    }
  },
  HelmetUrbanTrooper: {
    normal: {
      // S: 'RRGHECS00021',
      // M: 'RRGHECS00022',
      L: 'RRGHECS00023',
      XL: 'RRGHECS00024'
    }
  },
  HelmetFullFace: {
    VSRT04: {
      S: 'RRGHECS00025',
      M: 'RRGHECS00026',
      L: 'RRGHECS00027',
      XL: 'RRGHECS00028'
    }
  },
  TShirt: {
    normal: {
      S: 'SAMPLESKU1',
      M: 'SAMPLESKU2',
      L: 'SAMPLESKU3',
      XL: 'SAMPLESKU4'
    }
  }
};
export const tshirtSkuVariantMap = {
  '1': {
    'Off White': {
      S: 'RLATSN000547',
      M: 'RLATSN000548',
      L: 'RLATSN000549',
      XL: 'RLATSN000550',
      '2XL': 'RLATSN000551',
      '3XL': 'RLATSN000552'
    },
    Mustard: {
      S: 'RLATSN000553',
      M: 'RLATSN000554',
      L: 'RLATSN000555',
      XL: 'RLATSN000556',
      '2XL': 'RLATSN000557',
      '3XL': 'RLATSN000558'
    },
    Red: {
      S: 'RLATSN000559',
      M: 'RLATSN000560',
      L: 'RLATSN000561',
      XL: 'RLATSN000562',
      '2XL': 'RLATSN000563',
      '3XL': 'RLATSN000564'
    },
    Black: {
      S: 'RLATSN000565',
      M: 'RLATSN000566',
      L: 'RLATSN000567',
      XL: 'RLATSN000568',
      '2XL': 'RLATSN000569',
      '3XL': 'RLATSN000570'
    },
    Olive: {
      S: 'RLATSN000571',
      M: 'RLATSN000572',
      L: 'RLATSN000573',
      XL: 'RLATSN000574',
      '2XL': 'RLATSN000575',
      '3XL': 'RLATSN000576'
    },
    Navy: {
      S: 'RLATSN000577',
      M: 'RLATSN000578',
      L: 'RLATSN000579',
      XL: 'RLATSN000580',
      '2XL': 'RLATSN000581',
      '3XL': 'RLATSN000582'
    }
  },
  '2': {
    'Off White': {
      S: 'RLATSN000583',
      M: 'RLATSN000584',
      L: 'RLATSN000585',
      XL: 'RLATSN000586',
      '2XL': 'RLATSN000587',
      '3XL': 'RLATSN000588'
    },
    Mustard: {
      S: 'RLATSN000589',
      M: 'RLATSN000590',
      L: 'RLATSN000591',
      XL: 'RLATSN000592',
      '2XL': 'RLATSN000593',
      '3XL': 'RLATSN000594'
    },
    Red: {
      S: 'RLATSN000595',
      M: 'RLATSN000596',
      L: 'RLATSN000597',
      XL: 'RLATSN000598',
      '2XL': 'RLATSN000599',
      '3XL': 'RLATSN000600'
    },
    Black: {
      S: 'RLATSN000601',
      M: 'RLATSN000602',
      L: 'RLATSN000603',
      XL: 'RLATSN000604',
      '2XL': 'RLATSN000605',
      '3XL': 'RLATSN000606'
    },
    Olive: {
      S: 'RLATSN000607',
      M: 'RLATSN000608',
      L: 'RLATSN000609',
      XL: 'RLATSN000610',
      '2XL': 'RLATSN000611',
      '3XL': 'RLATSN000612'
    },
    Navy: {
      S: 'RLATSN000613',
      M: 'RLATSN000614',
      L: 'RLATSN000615',
      XL: 'RLATSN000616',
      '2XL': 'RLATSN000617',
      '3XL': 'RLATSN000618'
    }
  }
};

export const jacketSkuVariantMap = {
  streetwindV2: {
    Black: {
      S: 'RRGJKN000001',
      M: 'RRGJKN000002',
      L: 'RRGJKN000003',
      XL: 'RRGJKN000004',
      '2XL': 'RRGJKN000005',
      '3XL': 'RRGJKN000006'
    },
    Olive: {
      S: 'RRGJKN000007',
      M: 'RRGJKN000008',
      L: 'RRGJKN000009',
      XL: 'RRGJKN000010',
      '2XL': 'RRGJKN000011',
      '3XL': 'RRGJKN000012'
    },
    Red: {
      S: 'RRGJKN000013',
      M: 'RRGJKN000014',
      L: 'RRGJKN000015',
      XL: 'RRGJKN000016',
      '2XL': 'RRGJKN000017',
      '3XL': 'RRGJKN000018'
    },
    Grey: {
      S: 'RRGJKN000019',
      M: 'RRGJKN000020',
      L: 'RRGJKN000021',
      XL: 'RRGJKN000022',
      '2XL': 'RRGJKN000023',
      '3XL': 'RRGJKN000024'
    },
    Brown: {
      S: 'RRGJKN000025',
      M: 'RRGJKN000026',
      L: 'RRGJKN000027',
      XL: 'RRGJKN000028',
      '2XL': 'RRGJKN000029',
      '3XL': 'RRGJKN000030'
    }
  },
  windfarer: {
    Black: {
      S: 'RRGJKN000031',
      M: 'RRGJKN000032',
      L: 'RRGJKN000033',
      XL: 'RRGJKN000034',
      '2XL': 'RRGJKN000035',
      '3XL': 'RRGJKN000036'
    },
    Olive: {
      S: 'RRGJKN000037',
      M: 'RRGJKN000038',
      L: 'RRGJKN000039',
      XL: 'RRGJKN000040',
      '2XL': 'RRGJKN000041',
      '3XL': 'RRGJKN000042'
    }
  },
  explorerV3: {
    Black: {
      S: 'RRGJKN000043',
      M: 'RRGJKN000044',
      L: 'RRGJKN000045',
      XL: 'RRGJKN000046',
      '2XL': 'RRGJKN000047',
      '3XL': 'RRGJKN000048'
    },
    Grey: {
      S: 'RRGJKN000049',
      M: 'RRGJKN000050',
      L: 'RRGJKN000051',
      XL: 'RRGJKN000052',
      '2XL': 'RRGJKN000053',
      '3XL': 'RRGJKN000054'
    }
  },
  stormRaider: {
    Grey: {
      S: 'RRGJKN000079',
      M: 'RRGJKN000080',
      L: 'RRGJKN000081',
      XL: 'RRGJKN000082',
      '2XL': 'RRGJKN000083',
      '3XL': 'RRGJKN000084'
    }
  },
  khardungLaV2: {
    Olive: {
      S: 'RRGJKN000067',
      M: 'RRGJKN000068',
      L: 'RRGJKN000069',
      XL: 'RRGJKN000070',
      '2XL': 'RRGJKN000071',
      '3XL': 'RRGJKN000072'
    },
    Grey: {
      S: 'RRGJKN000073',
      M: 'RRGJKN000074',
      L: 'RRGJKN000075',
      XL: 'RRGJKN000076',
      '2XL': 'RRGJKN000077',
      '3XL': 'RRGJKN000078'
    }
  },
  nirvik: {
    Black: {
      S: 'RRGJKN000055',
      M: 'RRGJKN000056',
      L: 'RRGJKN000057',
      XL: 'RRGJKN000058',
      '2XL': 'RRGJKN000059',
      '3XL': 'RRGJKN000060'
    },
    Brown: {
      S: 'RRGJKN000061',
      M: 'RRGJKN000062',
      L: 'RRGJKN000063',
      XL: 'RRGJKN000064',
      '2XL': 'RRGJKN000065',
      '3XL': 'RRGJKN000066'
    }
  }
};

export const jacketSkuWinterMap = {
  WNT001: {
    Olive: {
      S: 'RRGRJN000049',
      M: 'RRGRJN000050',
      L: 'RRGRJN000051',
      XL: 'RRGRJN000052',
      '2XL': 'RRGRJN000053',
      '3XL': 'RRGRJN000054'
    },
    Black: {
      S: 'RRGRJN000055',
      M: 'RRGRJN000056',
      L: 'RRGRJN000057',
      XL: 'RRGRJN000058',
      '2XL': 'RRGRJN000059',
      '3XL': 'RRGRJN000060'
    }
  },
  WNT002: {
    Black: {
      S: 'RRGRJN000031',
      M: 'RRGRJN000032',
      L: 'RRGRJN000033',
      XL: 'RRGRJN000034',
      '2XL': 'RRGRJN000035',
      '3XL': 'RRGRJN000036'
    }
  },
  WNT003: {
    Black: {
      S: 'RRGRJN000043',
      M: 'RRGRJN000044',
      L: 'RRGRJN000045',
      XL: 'RRGRJN000046',
      '2XL': 'RRGRJN000047',
      '3XL': 'RRGRJN000048'
    }
  },
  WNT004: {
    Black: {
      S: 'RRGRJN000037',
      M: 'RRGRJN000038',
      L: 'RRGRJN000039',
      XL: 'RRGRJN000040',
      '2XL': 'RRGRJN000041',
      '3XL': 'RRGRJN000042'
    }
  }
};

export const jacketSkuRainMap = {
  Red: {
    S: 'RRGRJN000001',
    M: 'RRGRJN000002',
    L: 'RRGRJN000003',
    XL: 'RRGRJN000004',
    '2XL': 'RRGRJN000005',
    '3XL': 'RRGRJN000006'
  },
  Black: {
    S: 'RRGRJN000007',
    M: 'RRGRJN000008',
    L: 'RRGRJN000009',
    XL: 'RRGRJN000010',
    '2XL': 'RRGRJN000011',
    '3XL': 'RRGRJN000012'
  },
  Olive: {
    S: 'RRGRJN000013',
    M: 'RRGRJN000014',
    L: 'RRGRJN000015',
    XL: 'RRGRJN000016',
    '2XL': 'RRGRJN000017',
    '3XL': 'RRGRJN000018'
  },
  Blue: {
    S: 'RRGRJN000019',
    M: 'RRGRJN000020',
    L: 'RRGRJN000021',
    XL: 'RRGRJN000022',
    '2XL': 'RRGRJN000023',
    '3XL': 'RRGRJN000024'
  },
  Yellow: {
    S: 'RRGRJN000025',
    M: 'RRGRJN000026',
    L: 'RRGRJN000027',
    XL: 'RRGRJN000028',
    '2XL': 'RRGRJN000029',
    '3XL': 'RRGRJN000030'
  }
};

export const jacketSkuArmourMap = {
  ERM001: 'RRGPRN000022',
  ERM002: 'RRGPRN000023',
  ERM003: 'RRGPRN000030',
  ERM004: 'RRGPRN000031',
  CRM001: 'RRGPRN000028',
  BRM001: {
    S: 'RRGPRN000024',
    M: 'RRGPRN000024',
    L: 'RRGPRN000025',
    XL: 'RRGPRN000025',
    '2XL': 'RRGPRN000025',
    '3XL': 'RRGPRN000025'
  },
  BRM002: {
    S: 'RRGPRN000026',
    M: 'RRGPRN000026',
    L: 'RRGPRN000027',
    XL: 'RRGPRN000027',
    '2XL': 'RRGPRN000027',
    '3XL': 'RRGPRN000027'
  },
  BRM003: {
    S: 'RRGPRN000032',
    M: 'RRGPRN000032',
    L: 'RRGPRN000033',
    XL: 'RRGPRN000033',
    '2XL': 'RRGPRN000033',
    '3XL': 'RRGPRN000033'
  },
  BRM004: {
    S: 'RRGPRN000034',
    M: 'RRGPRN000034',
    L: 'RRGPRN000034',
    XL: 'RGPRN000034',
    '2XL': 'RGPRN000034',
    '3XL': 'RGPRN000034'
  }
};

export const tshirtBikeModelMap = {
  Himalayan: 1,
  'Bullet 350 ES': 2,
  'Bullet 500': 3,
  'Bullet Electra': 4,
  'Classic 350': 5,
  'Classic 500': 6,
  'Thunderbird 350': 7,
  'Thunderbird 500': 8,
  'Thunderbird 350X': 9,
  'Thunderbird 500X': 10,
  'GT 650': 11,
  'Interceptor 650': 12,
  'Meteor 350': 13
};

export const tshirtBadgeMap = {
  'RE Rectangle Badge': 23,
  'RE Line Badge': 31,
  'RE Curve Badge': 33,
  'RE Round Badge': 25,
  'Ride Storm Badge': 26,
  'Dirt Track Badge': 13,
  'Cali Badge': 15,
  'Wisdom Badge': 6,
  'Courage Badge': 7,
  'Ship Badge': 1,
  'Red Bottle Badge': 2,
  'Himalayan Badge': 20,
  'Thunderbird Badge': 18,
  'Classic 1 Badge': 41,
  'Classic 2 Badge': 24,
  'Classic 3 Badge': 42,
  'Classic 4 Badge': 43,
  'Classic 5 Badge': 44,
  'Bullet Badge': 16,
  'Female Rider Badge': 9,
  'Male Rider Badge': 10,
  'Flag Badge': 12,
  'Surf Badge': 37,
  'Sigil Badge': 27,
  'Horns Badge': 14,
  'Van Badge': 39,
  'Coconut Badge': 36,
  'Thunder Badge': 11,
  'RE Logo Badge': 40,
  'RE Logo Badge Sleeve': 40,
  'RE Rectangle Badge Sleeve': 23,
  'RE Line Badge Sleeve': 31,
  'RE Curve Badge Sleeve': 33,
  'RE Round Badge Sleeve': 25,
  'Ride Storm Badge Sleeve': 26,
  'Dirt Track Badge Sleeve': 13,
  'Cali Badge Sleeve': 15,
  'Wisdom Badge Sleeve': 6,
  'Courage Badge Sleeve': 7,
  'Ship Badge Sleeve': 1,
  'Red Bottle Badge Sleeve': 2,
  'Himalayan Badge Sleeve': 20,
  'Thunderbird Badge Sleeve': 18,
  'Classic 1 Badge Sleeve': 41,
  'Classic 2 Badge Sleeve': 24,
  'Classic 3 Badge Sleeve': 42,
  'Classic 4 Badge Sleeve': 43,
  'Classic 5 Badge Sleeve': 44,
  'Bullet Badge Sleeve': 16,
  'Female Rider Badge Sleeve': 9,
  'Male Rider Badge Sleeve': 10,
  'Flag Badge Sleeve': 12,
  'Surf Badge Sleeve': 37,
  'Sigil Badge Sleeve': 27,
  'Horns Badge Sleeve': 14,
  'Van Badge Sleeve': 39,
  'Coconut Badge Sleeve': 36,
  'Thunder Badge Sleeve': 11,
  'Guitar Badge': 3,
  'Brown Helm Badge': 22,
  'Power Badge': 28,
  'Love Badge': 29,
  'Respect Badge': 30,
  'Surf Board Badge': 38,
  'Guitar Badge Sleeve': 3,
  'Brown Helm Badge Sleeve': 22,
  'Power Badge Sleeve': 28,
  'Love Badge Sleeve': 29,
  'Respect Badge Sleeve': 30,
  'Surf Board Badge Sleeve': 38,
  'Parts Badge': 21,
  'Gold Helm Sleeve': 35,
  'Parts Badge Sleeve': 21,
  'Gold Helm Badge': 35
};

export const tshirtPrintMap = {
  'RE Vintage Poster': 1,
  'RE J Model': 2,
  'RE MLG Vintage Yellow': 3,
  'RE MLG Vintage Engine': 4,
  'RE MLG Cannon': 5,
  'Bike Outline Lamp': 6,
  'Bike Outline Side': 7,
  'Big Single Helmet': 8,
  'RE Badge Hand': 9,
  'Green Bullet Drawn': 10,
  'RE Pure Motorcycle': 11,
  'The Classic Poster': 12,
  'Classic Wheel Mountain': 13,
  'Easy Single Poster': 14,
  'Ride Better Himalayan': 15,
  'Desert Bullet Drawn': 16,
  'Skunkworks Drawn': 17,
  'TVT Chennai': 18,
  'Bike Filled Side': 19,
  'Blue Bike Side': 20,
  'Flying Flea': 21,
  'Trademark MLG': 22,
  'RE Red Vintage Poster': 23,
  'RE Crown Wing Badge': 24,
  'Classic Reimagined': 25,
  'Waves Wind Sun': 26,
  'Bullet Ouline Side': 27,
  'MLG Logo': 28,
  'Far Enough': 29,
  'Love Courage Passion': 30,
  'All Roads No Roads': 31,
  'Classic Waterpaint': 32,
  'Bullet Waterpaint': 33,
  'Racer Waterpaint': 34,
  'Fury Single': 35,
  'California State': 36,
  'Mojave Desert': 37,
  'RE Tools': 38,
  'Hole Shot': 39,
  'RE Parts Service': 40,
  'Bullet Pencil': 41,
  'Leave Home': 42,
  'Claifornia 1970': 43,
  'Classic Sketch Fill': 44,
  'Ride Thunder': 45,
  'Racer Pencil': 46,
  'Racer Sketch': 47,
  'RE Scramble': 48,
  'Explorers Tales': 49,
  'Frozen Ride': 50,
  'Pune Adventure': 51,
  'Himalayan Watercolour': 52,
  'Bear Bullet': 53,
  'Long Way Home': 54,
  'Twin Spark': 55,
  'Ride the World': 56,
  'Ride Long Home': 57,
  'Past Spirit 650': 58,
  'In the Dirt': 59,
  'Interceptor Pacific Waves': 60,
  'Interceptor 650': 61,
  Explore: 62,
  'Moto Dreams': 63,
  'Ride the Fort Trail': 64,
  "God's own country": 65,
  'Ride the waves': 66,
  'Explore the Himalayas': 67,
  Uluwatu: 68,
  'Lost Kingdom': 69,
  "World's highest airstrip": 70,
  Janbaaz: 71,
  'Aao ride karein': 72,
  'Live love Ride': 73,
  'Maut ka kuan 1': 74,
  'Maut ka kuan 2': 75,
  Basilica: 76,
  Capetown: 77,
  'Holi Himalayan': 78,
  'Ride safe helmet': 79,
  'Janbaaz parade': 80,
  'Ride safe avoid cow': 81,
  'Bullet meri jaan': 82,
  Legend: 83,
  'Coastal Trail': 84,
  'Ride the wave beach': 85,
  'Motorcycling way of life': 86,
  'Leave home all roads no roads': 87,
  'Urban trooper': 88,
  'Over the mountains and through the woods': 89,
  'Flying flea MLG': 90,
  'R I D E': 91,
  'Around the world': 92,
  'Wild and free': 93,
  'A lifetime of stories': 94,
  'Into space and beyond': 95,
  'MWL Ride safe': 96,
  'Timeless and legendary': 97,
  'Where next': 98,
  'Where next leave home': 99,
  'WD/CO': 100,
  'Bejod bemisaal': 101,
  'Bullet meri jaan manzil ka neeshan': 102,
  'Where next attire': 103,
  'Dekho magar pyaar se': 104
};

export const tshirtBikeColorMap = {
  'Himalayan Granite': '1A',
  'Himalayan Sleet': '1B',
  'Himalayan Snow': '1C',
  'Himalayan Rock Red': '1D',
  'Himalayan Lake Blue': '1E',
  'Himalayan Snow White': '1F',
  'Himalayan Granite Black': '1G',
  'Bullet 350 Black': '2A',
  'Bullet 350 ES Black': '3A',
  'Bullet 350 ES Maroon': '3B',
  'Bullet 350 ES Silver': '3C',
  'Bullet 500 Forest Green': '4A',
  'Bullet 500 Black': '4B',
  'Classic 350 Redditch Blue': '5A',
  'Classic 350 Redditch Green': '5B',
  'Classic 350 Redditch Red': '5C',
  'Classic 350 Gunmetal Grey': '5D',
  'Classic 350 Airborne Blue': '5E',
  'Classic 350 Stormrider Sand': '5F',
  'Classic 350 Ash': '5G',
  'Classic 350 Black': '5H',
  'Classic 350 Sliver': '5I',
  'Classic 350 Chestnut': '5J',
  'Classic 500 Battle Green': '6A',
  'Classic 500 Black': '6B',
  'Classic 500 Chrome Graphite': '6C',
  'Classic 500 Chrome Green': '6D',
  'Classic 500 Chrome Black': '6E',
  'Classic 500 Desert Storm': '6F',
  'Classic 500 Lagoon': '6G',
  'Classic 500 Squadron Blue': '6H',
  'Classic 500 Tan': '6I',
  'Classic 500 Sleath Black': '6J',
  'Thunderbird 350 Stone': '7A',
  'Thunderbird 350 Marine': '7B',
  'Thunderbird 350 Flicker': '7C',
  'Thunderbird 500 Stone': '8A',
  'Thunderbird 500 Marine': '8B',
  'Thunderbird 500 Flicker': '8C',
  'Thunderbird 350X Roving Red': '9A',
  'Thunderbird 350X Whimsical White': '9B',
  'Thunderbird 500X Drifter Blue': '10A',
  'Thunderbird 500X Getaway Orange': '10B',
  'GT 650 Black Magic': '11A',
  'GT 650 Dr. Mayhem': '11B',
  'GT 650 Ice Queen': '11C',
  'GT 650 Mister Clean': '11D',
  'GT 650 Ventura Blue': '11E',
  'Interceptor 650 Baker Express': '12A',
  'Interceptor 650 Glitter & Dust': '12B',
  'Interceptor 650 Mark Three': '12C',
  'Interceptor 650 Orange Crush': '12D',
  'Interceptor 650 Ravishing Red': '12E',
  'Interceptor 650 Silver Spectre': '12F',
  'Meteor 350 Supernova Blue': '13A',
  'Meteor 350 Supernova Brown': '13B',
  'Meteor 350 Stellar Red': '13C',
  'Meteor 350 Stellar Blue': '13D',
  'Meteor 350 Stellar Black': '13E',
  'Meteor 350 Fireball Red': '13F',
  'Meteor 350 Fireball Yellow': '13G'
};

export const orderJsonItemsHelmet = [
  {
    category: 'baseColor',
    icon:
      'https://reecommprod.blob.core.windows.net/re-assets/icons/base-color.png',
    selectedOption: ''
  },
  {
    category: 'decal',
    icon: 'https://reecommprod.blob.core.windows.net/re-assets/icons/decal.png',
    selectedOption: ''
  },
  {
    category: 'internalFabricColor',
    icon:
      'https://reecommprod.blob.core.windows.net/re-assets/icons/internal-fabric-color.png',
    selectedOption: ''
  },
  {
    category: 'visor',
    icon: 'https://reecommprod.blob.core.windows.net/re-assets/icons/visor.png',
    selectedOption: ''
  },
  {
    category: 'text',
    icon: 'https://reecommprod.blob.core.windows.net/re-assets/icons/text.png',
    selectedOption: ''
  },
  {
    category: 'textLine1',
    icon: 'https://reecommprod.blob.core.windows.net/re-assets/icons/text.png',
    selectedOption: ''
  },
  {
    category: 'textLine2',
    icon: 'https://reecommprod.blob.core.windows.net/re-assets/icons/text.png',
    selectedOption: ''
  },
  {
    category: 'finish',
    icon:
      'https://reecommprod.blob.core.windows.net/re-assets/icons/finish.png',
    selectedOption: ''
  },
  {
    category: 'visorColor/peakColor',
    icon:
      'https://reecommprod.blob.core.windows.net/re-assets/icons/visor-color.png',
    selectedOption: ''
  },
  {
    category: 'goggle',
    icon:
      'https://reecommprod.blob.core.windows.net/re-assets/icons/goggle.png',
    selectedOption: 'No'
  }
];

export const orderJsonItemsTshirt = [
  {
    category: 'baseShirtColor',
    icon:
      'https://reecommdev.blob.core.windows.net/re-assets/icons/base-color.png',
    selectedOption: ''
  },
  {
    category: 'frontPrint',
    icon:
      'https://reecommdev.blob.core.windows.net/re-assets/TShirtAssets/icons/print.png',
    selectedOption: ''
  },
  {
    category: 'bikeArtFront',
    icon:
      'https://reecommdev.blob.core.windows.net/re-assets/TShirtAssets/icons/motorcycle.png',
    selectedAngle: '',
    selectedColor: '',
    selectedModel: ''
  },
  {
    category: 'bikeArtFrontText',
    icon:
      'https://reecommdev.blob.core.windows.net/re-assets/TShirtAssets/icons/motorcycle.png',
    selectedOption: ''
  },
  {
    category: 'bikeArtFrontNumberPlate',
    icon:
      'https://reecommdev.blob.core.windows.net/re-assets/TShirtAssets/icons/motorcycle.png',
    selectedOption: ''
  },
  {
    category: 'bikeArtBack',
    icon:
      'https://reecommdev.blob.core.windows.net/re-assets/TShirtAssets/icons/motorcycle.png',
    selectedAngle: '',
    selectedColor: '',
    selectedModel: ''
  },
  {
    category: 'badge_TL',
    icon:
      'https://reecommdev.blob.core.windows.net/re-assets/TShirtAssets/icons/badge.png',
    selectedOption: ''
  },
  {
    category: 'badge_CT',
    icon:
      'https://reecommdev.blob.core.windows.net/re-assets/TShirtAssets/icons/badge.png',
    selectedOption: ''
  },
  {
    category: 'badge_TR',
    icon:
      'https://reecommdev.blob.core.windows.net/re-assets/TShirtAssets/icons/badge.png',
    selectedOption: ''
  },
  {
    category: 'badge_BL',
    icon:
      'https://reecommdev.blob.core.windows.net/re-assets/TShirtAssets/icons/badge.png',
    selectedOption: ''
  },
  {
    category: 'badge_BR',
    icon:
      'https://reecommdev.blob.core.windows.net/re-assets/TShirtAssets/icons/badge.png',
    selectedOption: ''
  },
  {
    category: 'bikeArtBackText',
    icon:
      'https://reecommdev.blob.core.windows.net/re-assets/TShirtAssets/icons/motorcycle.png',
    selectedOption: ''
  },
  {
    category: 'bikeArtBackNumberPlate',
    icon:
      'https://reecommdev.blob.core.windows.net/re-assets/TShirtAssets/icons/motorcycle.png',
    selectedOption: ''
  },
  {
    category: 'badge_SL',
    icon:
      'https://reecommdev.blob.core.windows.net/re-assets/TShirtAssets/icons/badge.png',
    selectedOption: ''
  },
  {
    category: 'badge_SR',
    icon:
      'https://reecommdev.blob.core.windows.net/re-assets/TShirtAssets/icons/badge.png',
    selectedOption: ''
  },

  {
    category: 'backText',
    icon:
      'https://reecommdev.blob.core.windows.net/re-assets/TShirtAssets/icons/text.png',
    selectedOption: ''
  }
];

export const orderJsonItemsJacket = [
  {
    category: 'jacketColour',
    icon:
      'https://reecommprod.blob.core.windows.net/re-assets/icons/base-color.png',
    selectedOption: ''
  },
  {
    category: 'elbowShouldArmour',
    icon: 'https://reecommprod.blob.core.windows.net/re-assets/icons/decal.png',
    selectedOption: ''
  },
  {
    category: 'chestArmour',
    icon:
      'https://reecommprod.blob.core.windows.net/re-assets/icons/internal-fabric-color.png',
    selectedOption: ''
  },
  {
    category: 'backArmour',
    icon: 'https://reecommprod.blob.core.windows.net/re-assets/icons/visor.png',
    selectedOption: ''
  },
  {
    category: 'winterProtection',
    icon: 'https://reecommprod.blob.core.windows.net/re-assets/icons/text.png',
    selectedOption: ''
  },
  {
    category: 'winterColor',
    icon: 'https://reecommprod.blob.core.windows.net/re-assets/icons/text.png',
    selectedOption: ''
  },
  {
    category: 'rainProtection',
    icon: 'https://reecommprod.blob.core.windows.net/re-assets/icons/text.png',
    selectedOption: ''
  }
];

const jacketsMaterialThumbnail =
  'https://reecommprod.blob.core.windows.net/re-assets/icons/material.png';
const jacketsVentilationThumbnail =
  'https://reecommprod.blob.core.windows.net/re-assets/icons/ventilation.png';
const jacketsErgonomicsThumbnail =
  'https://reecommprod.blob.core.windows.net/re-assets/icons/ergonomics.png';

export const jacketVariants = [
  {
    variantId: 'streetwindV2',
    features: [
      {
        thumbnail: jacketsMaterialThumbnail,
        title: 'Material',
        subTitle: '90% Polyester Mesh, 10% 600D Polyester'
      },
      {
        thumbnail: jacketsVentilationThumbnail,
        title: 'Ventilation',
        subTitle: 'Highly breathable all mesh construction'
      },
      {
        thumbnail: jacketsErgonomicsThumbnail,
        title: 'Ergonomics',
        subTitle: 'Adjustment tabs on cuffs, waist, biceps, and forearms'
      }
    ]
  },
  {
    variantId: 'windfarer',
    features: [
      {
        thumbnail: jacketsMaterialThumbnail,
        title: 'Material',
        subTitle:
          '90% high abrasion resistant Polyester Mesh, 10% 600D Polyester'
      },
      {
        thumbnail: jacketsVentilationThumbnail,
        title: 'Ventilation',
        subTitle: 'High airflow mesh construction'
      },
      {
        thumbnail: jacketsErgonomicsThumbnail,
        title: 'Ergonomics',
        subTitle: 'Adjustment tabs and cushioned comfort collar'
      }
    ]
  },
  {
    variantId: 'explorerV3',
    features: [
      {
        thumbnail: jacketsMaterialThumbnail,
        title: 'Material',
        subTitle: '600D high abrasion resistant Polyester with 40% mesh'
      },
      {
        thumbnail: jacketsVentilationThumbnail,
        title: 'Ventilation',
        subTitle: 'Strategic placement of mesh'
      },
      {
        thumbnail: jacketsErgonomicsThumbnail,
        title: 'Ergonomics',
        subTitle: 'Flexi snap collar closure and comes with adjustment tabs'
      }
    ]
  },
  {
    variantId: 'stormRaider',
    features: [
      {
        thumbnail: jacketsMaterialThumbnail,
        title: 'Material',
        subTitle: '600 D PU coated rainproof polyester fabric'
      },
      {
        thumbnail: jacketsVentilationThumbnail,
        title: 'Ventilation',
        subTitle: 'Strategic placement of Vents with zipper closures'
      },
      {
        thumbnail: jacketsErgonomicsThumbnail,
        title: 'Ergonomics',
        subTitle: 'Flexi snap collar closure and comes with adjustment tabs'
      }
    ]
  },
  {
    variantId: 'khardungLaV2',
    features: [
      {
        thumbnail: jacketsMaterialThumbnail,
        title: 'Material',
        subTitle: '600D Polyester Fabric'
      },
      {
        thumbnail: jacketsVentilationThumbnail,
        title: 'Ventilation',
        subTitle: 'Strategic placement of Vents with zipper closures'
      },
      {
        thumbnail: jacketsErgonomicsThumbnail,
        title: 'Ergonomics',
        subTitle: 'Flexi snap collar closure and comes with adjustment tabs'
      }
    ]
  },
  {
    variantId: 'nirvik',
    features: [
      {
        thumbnail: jacketsMaterialThumbnail,
        title: 'Material',
        subTitle: '500 D Nylon fabric'
      },
      {
        thumbnail: jacketsVentilationThumbnail,
        title: 'Ventilation',
        subTitle: 'Strategic placement of Vents with zipper closures'
      },
      {
        thumbnail: jacketsErgonomicsThumbnail,
        title: 'Ergonomics',
        subTitle: 'Flexi snap collar closure and comes with adjustment tabs'
      }
    ]
  }
];
